import React, { useState, useEffect } from 'react';
import "./UsersFilters.css";
import ExecuteAxios from "../../../Components/ExecuteAxios/ExecuteAxios";
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';
import Panel from 'Components/Panel/Panel';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';

function UsersFilters({
    onUpdateSectorsEmployees,
    onUpdateUserSelected,
    onUpdateResetUserList,
    onUpdateSectorIdSelected,
    onUpdateBenefitsIdSelected,
    onUpdateIdSelected,
    idsSelected,
    employeeSectorIdSelected,
    resetUserList
}) {
    const [employeeSelected, setEmployeeSelected] = useState();
    const debouncedEmployeeSelected = useDebouncedValue(employeeSelected);
    const [isActive, setIsActive] = useState('S');
    const [sectors, setSectors] = useState([]);

    function isActiveSetter() {
        return setIsActive(isActive === 'S' ? 'N' : 'S')
    }
    // Setores: ao abrir e quando a tela pede para recarregar (resetUserList = true)
    useEffect(() => {
        if (sectors.length > 0 && !resetUserList) {
            return;
        }
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        fetchData();
    }, [resetUserList]);

    // Recarga pedida pela tela (após salvar); a troca de setor/filtros é tratada no efeito dos filtros
    useEffect(() => {
        if (!resetUserList) {
            return;
        }
        const fetchData = async () => {
            await filterUsers(false);
            onUpdateResetUserList(false)
        };

        fetchData();
    }, [resetUserList]);


    useEffect(() => {
        onUpdateUserSelected([])
    }, [employeeSectorIdSelected]);


    async function filterUsers(updateUsersSelected = true) {
        if (updateUsersSelected) {
            onUpdateUserSelected([])
        }

        const parameters = {
            sectorId: employeeSectorIdSelected,
            name: employeeSelected,
            onlyActive: isActive
        };
        const employees = await ExecuteAxios.api('get', `/user/name`, { params: parameters })
        onUpdateSectorsEmployees(employees);
        RemoveIdsNotFound.remove(employees, onUpdateIdSelected, idsSelected)
    }

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)

    const filterUsersPanel = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    };

    const styleFilterButton = {
        width: '85px',
        margin: '10px 15px 10px 0px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer'
    };

    useEffect(() => {
        filterUsers()
    }, [employeeSectorIdSelected, debouncedEmployeeSelected, isActive]);


    return (
        <>
            <Panel style={filterUsersPanel}
                titlePage={'Filtros usuário'}
                canViewCRUD={true}
            >
                <LoadingIndicator loaded={true}>
                    <div id='first-colum-filter-sectors'>
                        <div id='filter-atributtes'>
                            <div id='sector-filter'>
                                <span className='span-sector-filter'>Setor</span>
                                <ComboBox setAttribute={onUpdateSectorIdSelected}
                                    optionsData={sectorOptions}
                                    style={{ width: '150px', cursor: 'pointer' }}
                                    value={employeeSectorIdSelected}
                                    defaultValue={employeeSectorIdSelected}
                                />
                            </div>

                            <div id='employee-filter'>
                                <span className='span-sector-filter'>Colaborador</span>
                                <InputField
                                    setAttribute={setEmployeeSelected}
                                    value={employeeSelected}
                                    style={{ width: '150px' }}
                                />
                            </div>

                            <div id='employee-filter'>
                                <span className='span-sector-filter'>Ativo</span>
                                <InputField
                                    setAttribute={(event) => isActiveSetter(event)}
                                    value={isActive}
                                    checked={isActive === 'S'}
                                    readOnly={false}
                                    disabled={false}
                                    type="checkbox"
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Panel>
        </>
    );
};

export default UsersFilters;